import { render, staticRenderFns } from "./AskHour.vue?vue&type=template&id=41189d72&"
import script from "./AskHour.vue?vue&type=script&lang=js&"
export * from "./AskHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports